import React from 'react';
import ReactDOM from 'react-dom/client';
import Search from './Pages/Search-new';
import Home from './Pages/Home';
import MinimumOrder from './Pages/MinimumOrder';
import Contacts from './Pages/Contacts';
import Error from './Components/Error';
import OrderStatus from './Pages/OrderStatus'
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  useSearchParams
} from "react-router-dom";
import Header from './Components/Header';
import { CookiesProvider } from 'react-cookie';
import CookieTracker from './Components/CookieTracker';

import Refund from './Pages/Refund';
import OrderPage from './Pages/OrderPage';

function OldPath() {
  // eslint-disable-next-line
  const [params, _] = useSearchParams()
  return <Navigate to={`/search?q=${params.get('code')}`} replace/>
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to='/home' replace/>,
    errorElement: <Error />
  },
  {
    path: "/home",
    element: <Home/>,
  },
  {
    path: "/search",
    element: <Search/>,
  },
  {
    path: "/ricercaProdotti",
    element: <OldPath/>,
  },
  {
    path: "/contacts",
    element: <Contacts/>,
  },
  {
    path: "/order",
    element: <MinimumOrder/>,
  },
  {
    path: "/order-status",
    element: <OrderStatus/>,
  },
  {
    path: "/refund",
    element: <Refund/>,
  },
  {
    path: "/OrderPage",
    element: <OrderPage/>,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CookiesProvider>
      <CookieTracker/>
      <Header/>
      <RouterProvider router={router}/>
    </CookiesProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
